// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var assetBundleBuildingsInitial = {
    buildings_initial_0: require("../assets/packed/buildings-initial/buildings-initial-0.json"),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleBuildingsInitial.ts
// module id = 1729
// module chunks = 3